export default __webpack_public_path__ + "static/media/B0004.4d5efa77.png";